import React from 'react';
import { Title } from '../../atoms';
import T from 'prop-types';

export const MenuItem = ({ title, icon, activeIcon, active, onClick, id }) => {
    return <div className={active ? "menuBoxActive" : "menuBox"} onClick={onClick} id={id}>
        <img src={active ? activeIcon : icon} />
        <Title className={active ? "menuTextActive text" : "menuTextCls text"} text={title} />
    </div>;
};

MenuItem.T = {
    title: T.string,
    icon: T.string,
    activeIcon: T.string,
    onClick: T.func,
    active: T.bool
};

